export default __webpack_public_path__ + "static/media/blueMarker.e0699a2c.svg";